import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../utils/api.js";
import type { OAuthProvider } from "./provider-icons.js";
import { ProviderButton } from "./provider-icons.js";
import { Card, CardContent, CardHeader } from "../ui/card.js";

const ERROR_MESSAGES: Record<string, string> = {
  invalid_state: "Something went wrong during sign-in. Please try again.",
  token_exchange_failed: "Something went wrong during sign-in. Please try again.",
  profile_fetch_failed: "Something went wrong during sign-in. Please try again.",
  no_email:
    "We couldn't find an email address for your account. Please use a different sign-in method.",
};

export function LoginPage() {
  const [providers, setProviders] = useState<OAuthProvider[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  useEffect(() => {
    api
      .get<{ providers: OAuthProvider[] }>("/auth/providers")
      .then((data) => setProviders(data.providers))
      .catch(() => setProviders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-sm">
        <CardHeader className="flex flex-col items-center text-center">
          <img src="/mantle-symbol.svg" alt="Mantle" className="size-20" />
          <div className="mt-2">
            <div className="text-sm font-semibold tracking-[0.2em] text-foreground">MANTLE</div>
            <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground">Talent</h1>
            <p className="mt-1 text-sm text-muted-foreground">Sign in to continue</p>
          </div>
        </CardHeader>

        <CardContent>
          {error && (
            <div className="mb-4 rounded-md bg-[var(--danger-bg)] px-4 py-3 text-sm text-[var(--danger-fg)]">
              {ERROR_MESSAGES[error] ?? "An unexpected error occurred. Please try again."}
            </div>
          )}

          {loading ? (
            <div className="text-center text-sm text-muted-foreground">Loading...</div>
          ) : providers.length === 0 ? (
            <div className="text-center text-sm text-muted-foreground">
              Sign-in is temporarily unavailable. Please try again later.
            </div>
          ) : (
            <div className="space-y-3">
              {providers.map((provider) => (
                <ProviderButton key={provider} provider={provider} />
              ))}
            </div>
          )}
        </CardContent>
        <div className="border-t border-border px-6 py-4 text-center font-mono text-[10px] tracking-[0.12em] text-muted-foreground uppercase">
          Mantle DC recruiting
        </div>
      </Card>
    </div>
  );
}
